import * as React from "react";

;
export const Indicator = (props: React.SVGProps<SVGSVGElement>) => <svg width={10} height={10} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fill="currentColor" d="M0 0h10v10H0z" /></svg>;